<template>
    <!-- 管理员根据条件筛选帖子 -->
    <div class="filter-conditions">
        <span class="filter-conditions-title">筛选条件：</span>

        <div class="filter-conditions-all">

            <!-- 流程状态筛选 -->
            <div v-if="hasOfficialProcess"
                class="filter-conditions-type">
                <span class="filter-conditions-type-label">处理状态</span>
                <veui-checkbox
                    v-model="isCheckedAll"
                    ui="small"
                >
                    全部
                </veui-checkbox>
                <veui-checkbox-group
                    class="filter-conditions-type-check"
                    ui="small"
                    v-model="selectedOfficialProcess"
                    :items="officialProcessOptions"
                    :readonly="isCheckedAll"
                />
            </div>

            <div v-if="hasOfficialProcess">
                <span class="filter-conditions-no-reply">只查未回复的帖子</span>
                <veui-checkbox
                    v-model="isReply"
                    ui="small"
                >
                </veui-checkbox>
            </div>

            <!-- 问题跟进人筛选 -->
            <div v-if="hasOfficialFollower"
                class="filter-conditions-type">
                <span class="filter-conditions-type-label">跟进人</span>

                <img v-if="selectedFollowInfo.avatar"
                    class="filter-conditions-type-avatar"
                    :src="selectedFollowInfo.avatar">
                <span v-if="selectedFollowInfo.nickname"
                    class="filter-conditions-type-name">
                    {{selectedFollowInfo.nickname}}
                </span>
                <span v-if="selectedFollowInfo.nickname"
                    class="fa fa-close filter-conditions-type-close"
                    @click="clearFollowInfo">
                </span>

                <veui-button ui="primary tiny"
                    class="filter-conditions-follower-btn"
                    @click="toggle('officialsupporter')">
                    选择人员
                </veui-button>
            </div>

            <!-- 联盟宿主筛选 -->
            <div v-if="hasOfficialAuthor"
                class="filter-conditions-type">
                <span class="filter-conditions-type-label">联盟宿主</span>

                <img v-if="selectedAuthorInfo.avatar"
                    class="filter-conditions-type-avatar"
                    :src="selectedAuthorInfo.avatar">
                <span v-if="selectedAuthorInfo.nickname"
                    class="filter-conditions-type-name">
                    {{selectedAuthorInfo.nickname}}
                </span>
                <span v-if="selectedAuthorInfo.nickname"
                    class="fa fa-close filter-conditions-type-close"
                    @click="clearAuthorInfo">
                </span>

                <veui-button ui="primary tiny"
                    class="filter-conditions-follower-btn"
                    @click="toggle('officialauthor')">
                    选择宿主
                </veui-button>
            </div>

            <!-- 时间段筛选 -->
            <div class="filter-conditions-type">
                <span class="filter-conditions-type-label">发布时间段</span>
                <date-time-picker ref="datetimefilter"></date-time-picker>
            </div>
        </div>

        <veui-button ui="primary tiny"
            class="filter-conditions-btn"
            @click="filterTopicList">
            筛选
        </veui-button>

        <!-- 人员列表确认弹窗 -->
        <follow-user-box v-if="isShowUserList"
            :confirm="isShowUserList"
            :selected="selectedId"
            :allownouser="allowNoUser"
            :listtype="userListType"
            @ok="changeSelectedUserInfo"
            @cancel="toggle">
        </follow-user-box>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-filter.less';
</style>

<script>
import {Button, CheckboxGroup, Checkbox} from 'veui';
import {mapState, mapGetters, mapActions} from 'vuex';

import DateTimePicker from './DateTimePicker.vue';
import FollowUserBox from '../FollowUserBox.vue';
import {notAllowScroll, allowScroll} from '@/utils/decorate/scroll';

export default {
    props: {
        existloc: {
            'type': String,
            'default': 'home'
        }
    },
    components: {
        'veui-button': Button,
        'veui-checkbox-group': CheckboxGroup,
        'veui-checkbox': Checkbox,
        'date-time-picker': DateTimePicker,
        'follow-user-box': FollowUserBox
    },
    data() {
        return {
            selectedId: -1,
            isShowUserList: false,
            allowNoUser: true,
            userListType: ''
        };
    },
    computed: {
        ...mapGetters([
            'hasSystemPermission'
        ]),
        ...mapState({
            officialProcessOptions: state => state.common.officialProcessOptions,
            // 筛选条件
            initProcessState: state => state.common.initProcessState,
            initSelectProcess: state => state.common.initSelectProcess,
            initReply: state => state.common.initReply,
            selectedFollowInfo: state => state.common.initFollowInfo,
            selectedAuthorInfo: state => state.common.initAuthorInfo,
            // selectedIssueFollowInfo: state => state.common.initIssueFollowInfo,
            selectedTime: state => state.common.initSelectedTime
        }),
        isCheckedAll: {
            get() {
                return this.initProcessState;
            },
            set(val) {
                this.$store.dispatch('setChecked', val);
            }
        },
        selectedOfficialProcess: {
            get() {
                return this.initSelectProcess;
            },
            set(val) {
                this.$store.dispatch('setCheckedProcess', val);
            }
        },
        // 获取只查未回复的帖子的状态
        isReply: {
            get() {
                return this.initReply;
            },
            set(val) {
                this.$store.dispatch('setReply', val);
            }
        },
        hasOfficialProcess() {
            return this.existloc === 'home';
        },
        hasOfficialFollower() {
            return this.existloc === 'home';
        },
        hasOfficialAuthor() {
            return this.existloc === 'home';
        }
    },
    methods: {
        ...mapActions([
            'clearFollowInfo',
            'clearAuthorInfo',
            'clearIssueFollowInfo',
            'setSelectedTime'
        ]),
        toggle(name) {
            if (!name) {
                name = this.userListType;
            }
            else {
                this.userListType = name;
            }
            switch (name) {
                case 'officialsupporter':
                    this.selectedId = this.selectedFollowInfo.id;
                    break;
                case 'officialauthor':
                    this.selectedId = this.selectedAuthorInfo.id;
                    break;
            }
            this.isShowUserList = !this.isShowUserList;
            if (this.isShowUserList) {
                notAllowScroll();
            }
            else {
                allowScroll();
            }
        },
        changeSelectedUserInfo(userInfo) {
            switch (this.userListType) {
                case 'officialsupporter':
                    this.$store.dispatch('changeFollower', userInfo);
                    break;
                case 'officialauthor':
                    this.$store.dispatch('changeAuthor', userInfo);
                    break;
            }
        },
        filterTopicList() {
            // 任意一项不为空即可筛选,筛选参数设置
            let routeName = this.$route.name;
            let routeParams =  Object.assign({}, this.$route.params);
            let routeQuery = Object.assign({}, this.$route.query);
            let query = {
                ...routeQuery
            };
            delete query.pageNo;

            if (!this.isCheckedAll) {
                query.officialProcess = [...this.selectedOfficialProcess];
            }

            query.lastNoReply = !this.isReply ? 0 : 1;

            if (this.selectedFollowInfo.id >= 0) {
                query.followUserId = this.selectedFollowInfo.id;
            }

            if (this.selectedAuthorInfo.id >= 0) {
                query.authorUserId = this.selectedAuthorInfo.id;
            }

            if (this.selectedTime) {
                query.createdTimeStart = this.selectedTime[0];
                query.createdTimeEnd = this.selectedTime[1];
            }

            // 设置筛选参数
            this.$store.dispatch('setFilterQuery', query);

            if (this.existloc === 'home') {
                this.getHomePageList(routeName, routeParams, routeQuery, query);
                // home 页数据
            }
        },
        getHomePageList(routeName, routeParams, routeQuery, query) {
            // 如果原来停留在非第一页，应从第一页开始
            if (routeQuery.pageNo) {
                delete routeQuery.pageNo;
                this.$router.push({name: routeName, params: routeParams, query: routeQuery});
            }
            else {
                this.$store.dispatch('getMainList', {params: routeParams, query});
            }
        }
    },
    destroyed() {
        this.$store.dispatch('clearFilterQuery');
    }
};
</script>
